import { unref } from "vue";
function unrefElement(ref) {
  const plain = unref(ref);
  return (plain == null ? void 0 : plain.$el) ?? plain;
}
export {
  unrefElement
};
//# sourceMappingURL=unrefElement.es.js.map
